import {getExpenseStatementList, getFinancialList, newExpenseStatement, uploadFinancialList,} from "@/api/expense";

const state = {
}

const mutations = {
}

const actions = {
  getExpenseStatementList({commit},data){
    return new Promise((resolve, reject) => {
      getExpenseStatementList(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  newExpenseStatement({commit},data){
    return new Promise((resolve, reject) => {
      newExpenseStatement(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  uploadfinanciallist({commit},data){
    return new Promise((resolve, reject) => {
      uploadFinancialList(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getfinanciallist({commit},data){
    return new Promise((resolve, reject) => {
      getFinancialList(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
